// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.koncierge-chat {
  position: relative;
  background: #f0f2f5;
  min-width: 400px;
}
.koncierge-chat ::-webkit-scrollbar {
  background: transparent;
  width: 6px;
}
.koncierge-chat ::-webkit-scrollbar-thumb {
  background: lightgray;
  width: 6px;
  border-radius: 6px;
}
.koncierge-chat .chat-messages {
  position: absolute;
  padding: 0 16px;
  top: 66px;
  bottom: 100px;
  left: 0;
  right: 0;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}
.koncierge-chat .chat-messages .message-code-blocks {
  display: flex;
  flex-direction: column;
}
.koncierge-chat .chat-messages .message-code-blocks .ant-btn {
  width: fit-content;
  margin-bottom: 8px;
}
.koncierge-chat .chat-messages .message-code-blocks .ant-btn .anticon {
  margin-top: 4px;
}
.koncierge-chat .chat-messages .message-code-blocks .message {
  display: flex;
  flex-direction: row;
  background-color: white;
  margin: 8px 0;
  padding: 8px;
  border-radius: 8px;
  width: fit-content;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  white-space: pre-wrap;
  font-size: 14px;
  max-width: 100%;
}
.koncierge-chat .chat-messages .message-code-blocks .message .markdown-renderer {
  max-width: 100%;
}
.koncierge-chat .chat-messages .message-code-blocks .message .markdown-renderer pre {
  background: #fffffff5;
  padding: 4px;
  border-radius: 4px;
}
.koncierge-chat .chat-messages .message-code-blocks .message .markdown-renderer ::-webkit-scrollbar {
  background: transparent;
  height: 6px;
}
.koncierge-chat .chat-messages .message-code-blocks .message .markdown-renderer ::-webkit-scrollbar-thumb {
  background: darkgray;
  height: 6px;
  border-radius: 6px;
}
.koncierge-chat .chat-messages .message-code-blocks .message .markdown-renderer pre {
  padding-bottom: 5px;
}
.koncierge-chat .chat-messages .message-code-blocks .chat-reply {
  background-color: rgba(102, 30, 255, 0.1);
  color: #000000ef;
}
.koncierge-chat .chat-messages .message-code-blocks .chat-reply ol {
  counter-reset: list-number;
}
.koncierge-chat .chat-messages .message-code-blocks .chat-reply ol li {
  counter-increment: list-number;
  list-style: none;
  position: relative;
}
.koncierge-chat .chat-messages .message-code-blocks .chat-reply ol li::before {
  position: absolute;
  content: counter(list-number) '.';
  top: 16px;
  left: -20px;
}
.koncierge-chat .chat-messages .message-code-blocks .chat-reply a {
  color: lightblue;
}
.chat-header {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: white;
  padding: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
}
.chat-header .ant-space-item {
  font-size: 18px;
}
.chat-header .ant-tag {
  font-family: monospace;
}
.bottom-input {
  position: absolute;
  border-top: 1px solid lightgray;
  width: 100%;
  max-width: inherit;
  display: flex;
  justify-content: center;
  bottom: 0;
  height: 100px;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px, rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px, rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;
}
.bottom-input .input-container {
  border-radius: inherit;
  padding: 0 1em;
  width: 100%;
  display: flex;
  max-width: 45em;
  align-items: center;
  justify-content: center;
  gap: 0.5em;
}
.bottom-input .input-container .send-button {
  cursor: pointer;
  font-size: 2em !important;
}
@keyframes dot-typing {
  0% {
    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px 0 0 0 #9880ff;
  }
  16.667% {
    box-shadow: 9984px -10px 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px 0 0 0 #9880ff;
  }
  33.333% {
    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px 0 0 0 #9880ff;
  }
  50% {
    box-shadow: 9984px 0 0 0 #9880ff, 9999px -10px 0 0 #9880ff, 10014px 0 0 0 #9880ff;
  }
  66.667% {
    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px 0 0 0 #9880ff;
  }
  83.333% {
    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px -10px 0 0 #9880ff;
  }
  100% {
    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px 0 0 0 #9880ff;
  }
}
.dot-typing {
  position: relative;
  top: 1.4em;
  left: -9999px;
  margin-left: 1em;
  width: 7px;
  height: 7px;
  border-radius: 5px;
  background-color: #9880ff;
  color: #9880ff;
  box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px 0 0 0 #9880ff;
  animation: dot-typing 1.5s infinite linear;
}
`, "",{"version":3,"sources":["webpack://./src/components/koncierge-chat/ChatPage.less"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAFA;EAMI,uBAAA;EACA,UAAA;AADJ;AANA;EAUI,qBAAA;EACA,UAAA;EACA,kBAAA;AADJ;AAXA;EAgBI,kBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;EACA,OAAA;EACA,QAAA;EACA,+BAAA;EACA,gBAAA;AAFJ;AArBA;EA0BM,aAAA;EACA,sBAAA;AAFN;AAzBA;EA6BQ,kBAAA;EACA,kBAAA;AADR;AA7BA;EAgCU,eAAA;AAAV;AAhCA;EAoCQ,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,wEAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;AADR;AA7CA;EAgDU,eAAA;AAAV;AAhDA;EAkDY,qBAAA;EACA,YAAA;EACA,kBAAA;AACZ;AArDA;EAuDY,uBAAA;EACA,WAAA;AACZ;AAzDA;EA2DY,oBAAA;EACA,WAAA;EACA,kBAAA;AACZ;AA9DA;EAgEY,mBAAA;AACZ;AAjEA;EAqEQ,yCAAA;EACA,gBAAA;AADR;AArEA;EAyEU,0BAAA;AADV;AAxEA;EA6EU,8BAAA;EACA,gBAAA;EACA,kBAAA;AAFV;AAIU;EACE,kBAAA;EACA,iCAAA;EACA,SAAA;EACA,WAAA;AAFZ;AAnFA;EAyFU,gBAAA;AAHV;AAUA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,aAAA;EAOA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,qNAAA;AAdF;AAJA;EAUI,eAAA;AAHJ;AAPA;EAaI,sBAAA;AAHJ;AAaA;EACE,kBAAA;EACA,+BAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,aAAA;EACA,qNAAA;AAXF;AAEA;EAaI,sBAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAZJ;AARA;EAsBM,eAAA;EACA,yBAAA;AAXN;AAgBA;EACE;IACE,6EAAA;EAdF;EAiBA;IACE,iFAAA;EAfF;EAkBA;IACE,6EAAA;EAhBF;EAmBA;IACE,iFAAA;EAjBF;EAoBA;IACE,6EAAA;EAlBF;EAqBA;IACE,iFAAA;EAnBF;EAsBA;IACE,6EAAA;EApBF;AACF;AAwBA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,6EAAA;EACA,0CAAA;AAtBF","sourcesContent":["@import '@css/variables.less';\n\n.koncierge-chat {\n  position: relative;\n  background: #f0f2f5;\n  min-width: 400px;\n\n  ::-webkit-scrollbar {\n    background: transparent;\n    width: 6px;\n  }\n  ::-webkit-scrollbar-thumb {\n    background: lightgray;\n    width: 6px;\n    border-radius: 6px;\n  }\n\n  .chat-messages {\n    position: absolute;\n    padding: 0 16px;\n    top: 66px;\n    bottom: 100px;\n    left: 0;\n    right: 0;\n    max-height: calc(100vh - 300px);\n    overflow-y: auto;\n\n    .message-code-blocks {\n      display: flex;\n      flex-direction: column;\n      .ant-btn {\n        width: fit-content;\n        margin-bottom: 8px;\n        .anticon {\n          margin-top: 4px;\n        }\n      }\n      .message {\n        display: flex;\n        flex-direction: row;\n        background-color: white;\n        margin: 8px 0;\n        padding: 8px;\n        border-radius: 8px;\n        width: fit-content;\n        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);\n        white-space: pre-wrap;\n        font-size: 14px;\n        max-width: 100%;\n        .markdown-renderer {\n          max-width: 100%;\n          pre {\n            background: #fffffff5;\n            padding: 4px;\n            border-radius: 4px;\n          }\n          ::-webkit-scrollbar {\n            background: transparent;\n            height: 6px;\n          }\n          ::-webkit-scrollbar-thumb {\n            background: darkgray;\n            height: 6px;\n            border-radius: 6px;\n          }\n          pre {\n            padding-bottom: 5px;\n          }\n        }\n      }\n      .chat-reply {\n        background-color: rgb(102 30 255 / 10%);\n        color: #000000ef;\n\n        ol {\n          counter-reset: list-number;\n        }\n\n        ol li {\n          counter-increment: list-number;\n          list-style: none;\n          position: relative;\n\n          &::before {\n            position: absolute;\n            content: counter(list-number) '.';\n            top: 16px;\n            left: -20px;\n          }\n        }\n        a {\n          color: lightblue;\n        }\n      }\n    }\n  }\n}\n\n.chat-header {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background-color: white;\n  padding: 16px;\n  .ant-space-item {\n    font-size: 18px;\n  }\n  .ant-tag {\n    font-family: monospace;\n  }\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px,\n    rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px,\n    rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;\n}\n\n.bottom-input {\n  position: absolute;\n  border-top: 1px solid lightgray;\n  width: 100%;\n  max-width: inherit;\n  display: flex;\n  justify-content: center;\n  bottom: 0;\n  height: 100px;\n  box-shadow: rgba(0, 0, 0, 0.07) 0px 1px 2px, rgba(0, 0, 0, 0.07) 0px 2px 4px,\n    rgba(0, 0, 0, 0.07) 0px 4px 8px, rgba(0, 0, 0, 0.07) 0px 8px 16px,\n    rgba(0, 0, 0, 0.07) 0px 16px 32px, rgba(0, 0, 0, 0.07) 0px 32px 64px;\n  .input-container {\n    border-radius: inherit;\n    padding: 0 1em;\n    width: 100%;\n    display: flex;\n    max-width: 45em;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5em;\n    .send-button {\n      cursor: pointer;\n      font-size: 2em !important;\n    }\n  }\n}\n\n@keyframes dot-typing {\n  0% {\n    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff,\n      10014px 0 0 0 #9880ff;\n  }\n  16.667% {\n    box-shadow: 9984px -10px 0 0 #9880ff, 9999px 0 0 0 #9880ff,\n      10014px 0 0 0 #9880ff;\n  }\n  33.333% {\n    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff,\n      10014px 0 0 0 #9880ff;\n  }\n  50% {\n    box-shadow: 9984px 0 0 0 #9880ff, 9999px -10px 0 0 #9880ff,\n      10014px 0 0 0 #9880ff;\n  }\n  66.667% {\n    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff,\n      10014px 0 0 0 #9880ff;\n  }\n  83.333% {\n    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff,\n      10014px -10px 0 0 #9880ff;\n  }\n  100% {\n    box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff,\n      10014px 0 0 0 #9880ff;\n  }\n}\n\n.dot-typing {\n  position: relative;\n  top: 1.4em;\n  left: -9999px;\n  margin-left: 1em;\n  width: 7px;\n  height: 7px;\n  border-radius: 5px;\n  background-color: #9880ff;\n  color: #9880ff;\n  box-shadow: 9984px 0 0 0 #9880ff, 9999px 0 0 0 #9880ff, 10014px 0 0 0 #9880ff;\n  animation: dot-typing 1.5s infinite linear;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
